import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const baseUrl = environment.apis.default.url;
    let url = '';
    if (req.url.startsWith('/api/app/')) {
      url = `${baseUrl}${req.url}`;
    } else {
      url = req.url;
    }
    const modifiedReq = req.clone({
      url: url,
    });
    return next.handle(modifiedReq);
  }
}
